import React from "react";
import { Form } from "react-bootstrap";

const ToggleSwitch = ({
  checked,
  onChange,
  labelOn = "Active",
  labelOff = "Inactive",
}) => {
  return (
    <div
      className="d-flex flex-column align-items-center cursor-pointer" 
      style={{ lineHeight: "1.2" }}
    >
      <Form.Check
        type="switch"
        id="custom-switch"
        checked={checked}
        onChange={onChange}
        className="m-0"
        style={{ cursor: "pointer", transform: "scale(1.2)" }}
      />
      <small style={{ fontWeight: 500, marginTop: "4px" }}>
        {checked ? labelOn : labelOff}
      </small>
    </div>
  );
};

export default ToggleSwitch;
